var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2915 2.87496C16.5432 2.62326 16.842 2.4236 17.1709 2.28738C17.4997 2.15117 17.8522 2.08105 18.2082 2.08105C18.5641 2.08105 18.9166 2.15117 19.2455 2.28738C19.5743 2.4236 19.8731 2.62326 20.1248 2.87496C20.3765 3.12666 20.5762 3.42548 20.7124 3.75434C20.8486 4.0832 20.9187 4.43567 20.9187 4.79163C20.9187 5.14759 20.8486 5.50006 20.7124 5.82892C20.5762 6.15779 20.3765 6.4566 20.1248 6.7083L7.18734 19.6458L1.9165 21.0833L3.354 15.8125L16.2915 2.87496Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon1);
export default __webpack_public_path__ + "static/media/edit-icon1.8a12b4f27f2aba08ff7b4ca8f5414077.svg";
export { ForwardRef as ReactComponent };